import PropTypes from 'prop-types';
import { useStepsContext } from '../contexts/StepsContext';
import {useEffect} from 'preact/hooks'
import {Icon} from "./index";

function Step({ title, style = {}, children, className, active, index, last, first, name }) {
    const { addStep, steps } = useStepsContext();
    useEffect(() => {
        addStep(title, active, last, first, name);
    }, []);
    active = (steps[index] && steps[index].active) ?? active;
    return (
        <>
            <Navigation label={title} step={index+1} mobileOnly={true} active={active} />
            <div
                className={`step ${active ? 'esc-ii-flex' : 'esc-ii-hidden'} esc-ii-flex-col${
                    className ? ' ' + className : ''
                }`}
                style={style}
            >
                {children}
            </div>
        </>
    );
}
Step.displayName = 'Step';

Step.propTypes = {
    style: PropTypes.object,
    title: PropTypes.string,
    className: PropTypes.string,
};

function ButtonGroup({ mobileOnly = false, desktopOnly = !mobileOnly, children }) {
    return (
        <div
        className={`${
            desktopOnly ? 'esc-ii-hidden lg:esc-ii-flex' : 'esc-ii-flex'
        } esc-ii-flex-col esc-ii-space-y-2${
            mobileOnly && ' lg:esc-ii-hidden'
        }`}
    >
        {children}
        </div>
    );
}

function NextButton({ mobileOnly = false, desktopOnly = !mobileOnly, title, onClick, disabled }) {
    const { goToNextStep } = useStepsContext();
    const containerClasses = [
        desktopOnly ? 'esc-ii-hidden lg:esc-ii-flex' : 'esc-ii-flex',
        'esc-ii-flex-col',
        'esc-ii-space-y-2',
        mobileOnly && 'lg:esc-ii-hidden',
    ];
    const buttonClasses = [
        'esc-ii-w-full esc-ii-py-5 esc-ii-rounded esc-ii-bg-primary esc-ii-mt-6',
        disabled && 'disabled:esc-ii-opacity-30'
    ]
    return (
        <div className={containerClasses.filter(Boolean).join(' ')}>
            <button
                type="button"
                className={buttonClasses.filter(Boolean).join(' ')}
                onClick={onClick ? onClick : goToNextStep}
                disabled={disabled}
            >
                <span className="esc-ii-text-white esc-ii-uppercase esc-ii-font-montserrat esc-ii-text-xs lg:esc-ii-text-base esc-ii-font-semibold">
                    {title}
                </span>
            </button>
        </div>
    );
}


function Navigation({
    children,
    className,
    step,
    label,
    active,
    mobileOnly = false,
}) {
    let StepIcon = () => <></>
    if (step > 0) {
        StepIcon = () => (
            <span className={`esc-ii-font-bold esc-ii-w-[26px] esc-ii-h-[26px] esc-ii-border esc-ii-text-center esc-ii-rounded-full${active ? ' esc-ii-bg-primary esc-ii-text-white esc-ii-border-primary' : ''}`}>
                {step}
            </span>
        )
    }

    // TODO: This is horrible and there's a much better way to do it.
    if (step === 1 && !active) {
        StepIcon = () => (
            <span className={`esc-ii-flex esc-ii-justify-center esc-ii-items-center esc-ii-font-bold esc-ii-w-[26px] esc-ii-h-[26px] esc-ii-border esc-ii-text-center esc-ii-rounded-full esc-ii-bg-blue esc-ii-border-blue`}>
                <Icon.Tick className="esc-ii-h-3 esc-ii-w-3" stroke={`#fff`} />
            </span>
        )
    }

    return (
        <header
            className={`esc-ii-flex esc-ii-flex-col esc-ii-mt-5 esc-ii-space-y-3${step > 1 ? ' esc-ii-mt-6' : ''}${
                mobileOnly && ' lg:esc-ii-hidden'
            }${className ? ' ' + className : ''}`}
        >
            <div className="esc-ii-flex esc-ii-items-center">
                <StepIcon />
                <h6 className={`esc-ii-no-underline esc-ii-font-montserrat esc-ii-text-xs esc-ii-uppercase esc-ii-ml-3 lg:esc-ii-text-sm${active || step === 1 ? ' esc-ii-font-bold' : ''}`}>
                    {label}
                </h6>
            </div>
        </header>
    );
}

Navigation.propTypes = {
    className: PropTypes.string,
    mobileOnly: PropTypes.bool,
    step: PropTypes.number,
    label: PropTypes.string,
};

Step.NextButton = NextButton;
Step.Navigation = Navigation;
Step.ButtonGroup = ButtonGroup;

export default Step;
